import './style.scss';
import {
  IProjectInfo,
  IProjectDocInfoMenu,
} from '../../../model/api-modules/document';

interface IProps {
  readonly currentProject: IProjectInfo;
  readonly activeDocuments: ReadonlyArray<IProjectDocInfoMenu> | undefined;
  readonly joinPath: (
    projectId: string | number,
    docId?: string | number
  ) => void;
}

export const DocumentNav = (props: IProps) => {
  return (
    <div className="c-header" id="containerContentHeader">
      {props.currentProject && (
        <div className="c-header-nav">
          <ul>
            <li>
              <span
                className="nav-item-name"
                style={{
                  color: props.activeDocuments?.length ? '#4E5969' : '#165DFF',
                }}
                onClick={() => props.joinPath(props.currentProject?.id)}
              >
                {props.currentProject.name}
              </span>
            </li>
            {props.activeDocuments &&
              props.activeDocuments?.length !== 0 &&
              props.activeDocuments?.map(
                (item: IProjectDocInfoMenu, index: number) => {
                  return (
                    <li key={item.id}>
                      <span>/</span>
                      <span
                        className="nav-item-name"
                        style={{
                          color:
                            props.activeDocuments &&
                            index === props.activeDocuments.length - 1
                              ? '#165DFF'
                              : '#4E5969',
                        }}
                        onClick={() => props.joinPath(item.project_id, item.id)}
                      >
                        {item.name}
                      </span>
                    </li>
                  );
                }
              )}
          </ul>
        </div>
      )}
    </div>
  );
};
